export default "__VITE_ASSET__DZEav1ih__"